<div>
  <app-logo class="text-(--resparke-primary-50)"></app-logo>
</div>
<router-outlet #router></router-outlet>